<template lang="pug">

#app
    //- h1 這裡是APP
    header#topBar
        b-container
            b-navbar(toggleable='lg' type='dark')
                .left
                    router-link.navbar-brand(to="/")
                        img.d-inline-block.align-top(src="@/assets/NANYAlogo_2.svg")
                b-navbar-toggle(target='nav-collapse')
                b-collapse#nav-collapse(is-nav='')
                    //- b-navbar-nav
                        //- b-nav-item(href='#' disabled='') Disabled
                    //- Right aligned nav items
                    b-navbar-nav.ml-auto
                        //- b-nav-item-dropdown(text="產品介紹" @mouseover="dropdown_hover()" @mouseleave="dropdown_hover()" @click="dropdown_hover()").nav_product.d-none.d-lg-block
                        b-nav-item-dropdown(text="PRODUCTS").nav_product.d-none.d-lg-block
                            b-dropdown-item(href="#" disabled) APPLICATION
                            b-dropdown-item(href="Food-and-medicine") Food and Medical use
                            b-dropdown-item(href="anti_static") Antistatic Packaging
                            b-dropdown-item.invisible(href="#") none
                            b-dropdown-item(href="decoration") Decoration Materials
                            b-dropdown-item(href="card_Lamination") Card Lamination
                            b-dropdown-item.invisible(href="#") none
                            b-dropdown-item(href="office_stationery") For Stationery
                            b-dropdown-item(href="water_treatment") Cooling Tower
                            b-dropdown-item.invisible(href="#") none
                            b-dropdown-item(href="green_apet") GREEN APET
                            b-dropdown-item(href="Cpet-sheet") C-PET SHEET
                            b-dropdown-item(href="#" disabled).nav_hr
                                hr
                            b-dropdown-item(href="#" disabled) PROCESSING
                            b-dropdown-item(href="vacuum_forming") Vacuum Molding
                            b-dropdown-item(href="folding_forming") Fold Molding
                            b-dropdown-item.invisible(href="#") none
                            b-dropdown-item(href="heat_seal") Heat Sealing
                            b-dropdown-item(href="print") Printing
                            b-dropdown-item.invisible(href="#") none
                            b-dropdown-item(href="plating") Metalize
                            b-dropdown-item(href="#" disabled).nav_hr
                                hr
                            b-dropdown-item(href="https://www.nanya-plastics-mall.com/" target="_blank").hrefmall More Nan Ya Products  
                                span
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="transform:translateY(-1px)">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" transform="scale(0.8) translate(3 2) " />
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    </svg>
                            b-dropdown-item(href="#" disabled).nav_hr
                                hr
                        b-nav-item-dropdown(text="PRODUCRS").nav_product.d-block.d-lg-none
                            div.sub_category
                                div.sub_title(:class="{ active: sub_menu_show[0].show }" @click='sub_menu_change("application")') APPLICATION
                                div.sub_menu(:class="{ active: sub_menu_show[0].show }" )
                                    router-link.nav-link(to="Food-and-medicine") Food and Medical use
                                    router-link.nav-link(to="anti_static") Antistatic Packaging
                                    router-link.nav-link(to="decoration") Decoration Materials
                                    router-link.nav-link(to="card_Lamination") Card Lamination
                                    router-link.nav-link(to="office_stationery") For Stationery
                                    router-link.nav-link(to="water_treatment") Cooling Tower
                                    router-link.nav-link(to="green_apet") GREEN APET
                                    router-link.nav-link(to="Cpet-sheet") C-PET SHEET
                            div.sub_category
                                div.sub_title(:class="{ active: sub_menu_show[1].show }" @click='sub_menu_change("processing")') PROCESSING
                                div.sub_menu(:class="{ active: sub_menu_show[1].show }" )
                                    router-link.nav-link(to="vacuum_forming") Vacuum Molding
                                    router-link.nav-link(to="folding_forming") Fold Molding
                                    router-link.nav-link(to="heat_seal") Heat Sealing
                                    router-link.nav-link(to="print") Printing
                                    router-link.nav-link(to="plating") Metalize
                            div.sub_category
                                div.hrefmall 
                                    a(href="https://www.nanya-plastics-mall.com/" target="_blank") More Nan Ya Products
                                        span
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="transform:translateY(-1px)">
                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" transform="scale(0.8) translate(3 2) " />
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            </svg>
                        //- b-nav-item(href='#') 產品介紹
                        router-link.nav-link(to="certification") CERTIFICATION
                        //- b-nav-item(href='#') 品質認證
                        router-link.nav-link(to="about") ABOUT
                        //- b-nav-item(href='#/about') 關於南亞
                        router-link.nav-link(to="contact") CONTACT
                        //- b-nav-item(href='#') 聯絡我們
                        b-nav-item-dropdown(text="LAN").nav_product.nav_lan.mb-5.mb-lg-0
                            b-dropdown-item(href="https://www.nan-ya-pvc.com.tw/") 繁
    transition(name="slide-fade")
        router-view
    
    footer#bottom_Block
        div
            b-container.px-0
                b-row.bottom
                    b-col.col_1(xl="4" lg="4")
                        h2 NAN YA RIGID FILM
                        div.footer_nanya_mall
                            a(href="https://www.nanya-plastics-mall.com/" target="_blank") More Nan Ya Products
                                span(style=" display: inline-block; padding-left: 20px;")
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="transform:translateY(-1px)">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" transform="scale(0.8) translate(3 2) " />
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    </svg>
                                img(src="/../img/nanya_mall.png")
                    b-col.col_2(xl="4" lg="4")
                        b-row
                            b-col(cols="12")
                                h4.rowTitle APPLICATION
                                h4 
                                    router-link(to="Food-and-medicine") Food and Medical use
                                h4
                                    router-link(to="anti_static") Antistatic Packaging
                                h4 
                                    router-link(to="card_Lamination") Card Lamination
                                h4 
                                    router-link(to="office_stationery") For Stationery
                                h4 
                                    router-link(to="decoration") Decoration Materials
                                h4 
                                    router-link(to="water_treatment") Cooling Tower
                                h4 
                                    router-link(to="green_apet") GREEN APET
                                h4 
                                    router-link(to="Cpet-sheet") C-PET SHEET
                    b-col.col_3(xl="4" lg="4")
                        b-row
                            b-col(cols="12")
                                h4.rowTitle PROCESSING
                                h4 
                                    router-link(to="vacuum_forming") Vacuum Molding
                                h4 
                                    router-link(to="folding_forming") Fold Molding
                                h4 
                                    router-link(to="heat_seal") Heat Sealing
                                h4 
                                    router-link(to="print") Printing
                                h4
                                    router-link(to="plating") Metalize
                //- 手機版面選單，預設display: none
                b-row.bottom_mobile
                    b-col(cols="12")
                        b-row
                            b-col.col_4
                                b-row
                                    b-col.col_4_title(cols="12")
                                        h4.rowTitle APPLICATION
                                b-row
                                    b-col.col_4_1(cols="5")
                                        h4
                                            router-link(to="Food-and-medicine") Food and Medical use
                                        h4 
                                            router-link(to="anti_static") Antistatic Packaging
                                        h4 
                                            router-link(to="green_apet") GREEN APET
                                    b-col.col_4_2(cols="4")
                                        h4 
                                            router-link(to="card_Lamination") Card Lamination
                                        h4 
                                            router-link(to="office_stationery") For Stationery
                                        h4 
                                            router-link(to="Cpet-sheet") C-PET SHEET
                                    b-col.col_4_3(cols="3")
                                        h4 
                                            router-link(to="decoration") Decoration Materials
                                        h4 
                                            router-link(to="water_treatment") Cooling Tower
                        b-row
                            b-col.col_5
                                b-row
                                    b-col.col_5_title(cols="12")
                                        h4.rowTitle PROCESSING
                                b-row
                                    b-col.col_5_1(cols="5")
                                        h4 
                                            router-link(to="vacuum_forming") Vacuum Molding
                                        h4 
                                            router-link(to="folding_forming") Fold Molding
                                    b-col.col_5_2(cols="4")
                                        h4 
                                            router-link(to="heat_seal")  Heat Sealing
                                        h4 
                                            router-link(to="print") Printing
                                    b-col.col_5_3(cols="3")
                                        h4 
                                            router-link(to="plating") Metalize
                        b-row
                            b-col.col_5
                                b-row
                                    b-col.col_5_title(cols="12")
                                        h4.rowTitle OTHERS
                                b-row
                                    b-col.col_5_1(cols="12")
                                        div.footer_nanya_mall
                                            a(href="https://www.nanya-plastics-mall.com/" target="_blank") More Nan Ya Products
                                                span(style=" display: inline-block; padding-left: 20px;")
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="transform:translateY(-1px)">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" transform="scale(0.8) translate(3 2) " />
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    </svg>
                                                img(src="/../img/nanya_mall.png")
        b-container.px-0(fluid)
            #copyRight
                p Copyright © 2021 NAN YA PLASTICS CORPORATION All Right Reserved
                p.pt-1 (NPC, Mar 1, 2023)

</template>

<script>
export default {
    // metaInfo: {
    //     title: '南亞硬質膠布',
    //     titleTemplate: '',
    //     meta: [
    //         { charset: 'utf-8' },
    //         { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    //     ],
    //     htmlAttrs: {
    //         lang: 'en',
    //         amp: true
    //     },
    // },
    data() {
        return{
            sub_menu_show: [
                {
                    name: "application",
                    show: true},
                {
                    name: "processing",
                    show: false}
            ]
        }
    },
    methods: {
        sub_menu_change:function(item) {
            // if(item === 'application'){
            //     this.sub_menu_show[0].show = true
            //     this.sub_menu_show[1].show = false
            // }
            // else{
            //     this.sub_menu_show[1].show = true
            //     this.sub_menu_show[0].show = false
            // }

            if(item === 'application'){
                this.sub_menu_show[0].show = !this.sub_menu_show[0].show
            }
            if(item === 'processing'){
                this.sub_menu_show[1].show = !this.sub_menu_show[1].show
            }
        },
        // dropdown_hover(evt) {
        //     $(".b-nav-dropdown .dropdown-toggle").click()
        //     evt.stopPropagation();
        // }
    }
}
</script>

<style lang="sass">

html, body
    margin: 0
    padding: 0
    min-width: 320px
#app 
    font-family: "微軟正黑體", Avenir, Helvetica, Arial, sans-serif

// 頁面切換動畫
.slide-fade-enter-active 
    animation: fadeInLeft 0.3s

.slide-fade-leave-active 
    animation: fadeOutLeft 0.5s

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ 
    // transform: translateX(10px)
    // opacity: 0

//WOW動畫
.animate_fadeinup
    animation: fadeInUp 2.5s
.animate_left
    animation: fadeInLeft 2.5s
.animate_right
    animation: fadeInRight 2.5s

.color_first
    color:#5b9ecb

.bgc_first
    background-color: #80badb
.bgc_second
    background-color: #fafafa

.mask
    position: absolute
    top: 0
    width: 100%
    height: 100%
    background-image: linear-gradient(248deg, rgba(0, 0, 0,0.60) 100%, rgba(0, 0, 0,0.60) 100%)
.mask_banner
    position: absolute
    top: 0
    width: 100%
    height: 100%
    background-image: linear-gradient(248deg, rgba(0, 0, 0,0.40) 100%, rgba(0, 0, 0,0.40) 100%)

.breadcrumb-item
    a, span
        color: #FFFFFF
    a:hover
        text-decoration: none
        color: rgba(255, 255, 255, 0.70 )
.breadcrumb-item + .breadcrumb-item::before 
    color: #FFFFFF !important

.banner_h1 
    position: absolute
    bottom: 20px
    width: 100%
    h1
        text-align: center
        font-weight: bolder
        color: #FFFFFF
        letter-spacing: 10.19px
        font-size: 46px
        @media all and ( max-width: 991px )
            font-size: 32px
        @media all and ( max-width: 767px )
            font-size: 24px
        @media all and ( max-width: 480px )
            letter-spacing: 2px
.banner
    .picture
        img
        .big
            display: block
            @media all and ( min-width: 1800px )
                width: 100%
        .small
            display: none
        @media all and ( max-width: 767px )
            .big
                display: none
            .small
                display: block
    @media all and ( min-width: 1440px )
        display: block
        overflow: hidden
        height: 400px
        picture
            display: block
            img
                position: absolute
                top: 0
                bottom: 0
                margin: auto
            
                    

$ThemeColor: #144361
$titleBarColor: #bfdce3
$titleBlockWidth: 220px

@mixin size($w, $h:$w)
    width: $w
    height: $h
@mixin pseudoBlock($w, $h:$w)
    content: ''
    display: block
    +size($w, $h)

// ------RWD裝置尺寸設定------- //
$large_media: 1200px
$big_media: 992px
$medium_media: 768px + 1px
$small_media: 576px

// 特大
@mixin desktop_width()
    @media all and (min-width: $large_media)
        @content
// 大>特大
@mixin desktop_small_width()
    @media all and (min-width: $big_media) and (max-width: $large_media)
        @content
// 中>大
@mixin tablet_width()
    @media all and (min-width: $medium_media) and (max-width: $big_media)
        @content
// 小>中
@mixin tablet_small_width()
    @media all and (min-width: $small_media) and (max-width: $medium_media)
        @content
// 小
@mixin phone_width()
    @media all and (max-width: $small_media)
        @content

// ------RWD裝置尺寸設定------- //

// 麵包屑
.breadcrumb_block
    position: absolute
    width: 100%
    top: 0
    .container
        @include desktop_width
            min-width: 96%
            margin: 0% 4%
            padding-right: 4%
            padding-left: 20px
        @include tablet_width
            
        @include tablet_small_width
            
        @include phone_width
            padding: 3px 0px

// 導覽列
#topBar
    background-color: $ThemeColor
    // background: linear-gradient(-150deg, $barColor 70%, #fff)
    font-weight: bold
    font-family: Arial, "Noto Sans", sans-serif, "微軟正黑體"
    text-align: center
    padding: 8px 0px
    @include tablet_width
        
    @include tablet_small_width
        padding: 0
    @include phone_width
        padding: 0
    .container
        @include desktop_width
            min-width: 96%
            margin: 0% 4%
            padding-right: 4%
        @include tablet_width
            
        @include tablet_small_width
            
        @include phone_width
            padding: 3px 0px

        .left
            letter-spacing: 2px
            
            img
                +size($titleBlockWidth, auto)
                cursor: pointer
                $height: 43.66px
                height: $height
                @include tablet_width
                    
                @include tablet_small_width
                    width: 180px
                    height: $height
                @include phone_width
                    width: 150px
                    height: $height - 15px

    // 導覽列位置大小設定
    .navbar
        @include tablet_width
                    
        @include tablet_small_width
            
        @include phone_width
            padding: 4px 0px
        
    // 導覽列文字顏色
    .navbar-nav .nav-link
        color: white
        +size(auto, 30px)
        font-stretch: normal
        font-size: 18px
        letter-spacing: 1.31px
        text-align: center
        line-height: 16px
        margin: 0
        padding: 8px 30px
        outline: none
        @media all and ( min-width: 992px )
            &:hover
                color: #80badb
        @media all and ( max-width: 1140px )
            padding: 8px 22px
    // 導覽列伸縮選單
    .navbar-toggler
        outline: none
        @include phone_width
            font-size: 1rem
            margin-right: 10px
    
    @media all and ( min-width: 992px )
        padding: 0
        .navbar
            padding: 0 1rem
        .navbar-nav .nav-link
            height: 85px 
            line-height: 72px

    .nav_product 
        .dropdown-menu.show
            background-color: rgba(255, 255, 255, 0.49)
        @media all and ( min-width: 992px )
            .dropdown-menu.show
                width: 640px
                display: flex
                flex-wrap: wrap
                top: 82px
                left: -170px
                background-color: rgba(128, 186, 219, 0.95)
                li
                    flex: 0 0 33%
                    text-align: center
                    .dropdown-item
                        color: #ffffff
                        font-weight: bold
                        text-align: left
                    .disabled
                        color: #144361
                        text-align: center
                    .dropdown-item:hover, .dropdown-item:focus 
                        background-color: rgba(255, 255, 255, 0)
                        text-decoration: underline
                li.hrefmall
                    flex: 0 0 100%
                    .dropdown-item
                        color: #144361
                        height: 100%
                        padding-left: 9%
                        span
                            display: inline-block
                            width: 20px
                            height: 20px
                .nav_hr
                    flex: 0 0 100%
                    hr
                        border-top: 1px solid rgba(20, 67, 97, 0.38)
        @media all and ( min-width: 992px )
            .dropdown-toggle::after
                display: none
        @media all and ( max-width: 991px )
            .dropdown-toggle
                display: block
                height: 60px !important
                line-height: 50px !important
            .dropdown-toggle::after
                position: absolute
                right: 40px
                top: 20px
                width: 12px
                height: 12px
                border-top: 1px solid #FFFFFF
                border-left: 1px solid #FFFFFF
                border-right: 0
                transform: rotate(225deg)
            .dropdown-toggle[aria-expanded="true"]::after
                transform: rotate(45deg)
            .dropdown-menu.show
                border: none
                border-radius: 0
        .sub_category
            margin: 20px 31px
            .sub_title
                position: relative
                letter-spacing: 0.96px
                color: #144361
                font-weight: bold
                height: 28px
                line-height: 28px
                &::before
                    content: ""
                    display: block
                    width: 12px
                    height: 12px
                    border-top: 1px solid #144361
                    border-left: 1px solid #144361
                    transform: rotate(225deg)
                    position: absolute
                    right: 9px
                    top: 5px
            .sub_title.active
                text-decoration: underline
                &::before
                    transform: rotate(45deg)
                    top: 12px
            .sub_menu
                height: 0
                overflow: hidden
                transition: .4s ease-in-out
                a
                    margin-left: 0
                    color: rgba(0, 0, 0, 0.79)
                    font-size: 14px
                    letter-spacing: 0.84px
            .sub_menu.active
                height: 360px
            &:nth-child(2)
                .sub_menu.active
                    height: 225px
            .hrefmall
                a
                    color: #144361
    .nav_product.nav_lan
        @media all and ( min-width: 992px )
            .dropdown-menu.show
                width: 66px
                min-width: auto
                left: 10px
        @media all and ( min-width: 1140px )
            .dropdown-menu.show
                left: 17px
        @media all and ( max-width: 991px )       
            .dropdown-item:hover, .dropdown-item:focus 
                background-color: rgba(255, 255, 255, 0)
                text-decoration: underline

@media (max-width: 991px)
    header 
        position: fixed
        width: 100%
        top: 0
        z-index: 99
        .container
            max-width: 100% !important
            padding: 0 !important
            .left
                margin-bottom: 0.5rem
                padding-left: 10px

    .navbar-dark .navbar-toggler-icon 
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important
    .navbar-dark .navbar-toggler[aria-expanded=true] .navbar-toggler-icon 
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M7.2,21.8L22.8,6.2 M7.2,6.2l15.6,15.6'/%3e%3c/svg%3e") !important
    .navbar-nav 
        height: calc( 100vh - 56px )
        background-color: rgba(128, 186, 219, 0.95)
        text-align: center
        overflow-y: auto
        padding-top: 25px   
        .nav-link
            text-align: left !important
            height: 45px !important
            line-height: 32px !important
        > .nav-link
            height: 60px !important
            line-height: 50px !important
    .navbar 
        padding: 0.5rem 0 0 0 !important
    #topBar .navbar-toggler 
        margin-right: 15px !important
        margin-bottom: 0.5rem
        border: none

#APET_home, #about, #certificate, #contact, #food_package, #anti_static, #decoration, #card_Lamination, #office_stationery, #water_treatment, #vacuum_forming, #folding_forming, #heat_seal, #print, #food_package, #green_apet_sheet, #Cpet_sheet
    @media (max-width: 991px)
        margin-top: 85px
    @media (max-width: 768px)
        margin-top: 69.66px
    @media (max-width: 576px)
        margin-top: 56px


#bottom_Block
    // @include tablet_width()
    //     margin-top: 375px
    // @include tablet_small_width()
    //     margin-top: 560px
    // @include phone_width()
    //     margin-top: 400px
    // @media all and (max-width: 380px)
    //     margin-top: 480px

    // 選單欄位標題設定-------vvvvvvvvvv------------
    > div
        &:nth-child(1)
            background-color: $ThemeColor
    @mixin rowTitle_Setting()
        position: relative
        width: fit-content
        @media all and (max-width: $big_media)
            margin-left: 25px

        &:before
            +pseudoBlock(4px,100%)
            left: -20px
            top: 0
            background-color: white
            position: absolute
            @media all and (max-width: $big_media)
                width: 2px
                transform: rotate(30deg)
        &:after
            +pseudoBlock(2px,100%)
            top: 0
            right: -20px
            transform: rotate(30deg)
            background-color: white
            position: absolute
            display: none
            @media all and (max-width: $big_media)
                display: block
    // 選單欄位標題設定-------^^^^^^^^^^------------

    @mixin bottom_Text_Setting($width, $height, $font_size, $letter-spacing, $line-height:normal)
        +size($width, $height)
        background-color: $ThemeColor
        color: white
        font-family: 微軟正黑體
        font-weight: bold
        font-stretch: normal
        font-style: normal
        // font-size: $font_size
        letter-spacing: $letter-spacing
        line-height: $line-height
        text-align: left
        margin: 0
        h4
            font-size: $font_size
            a
                color: #ffffff
                &:hover, &:focus
                    text-decoration: none
                    color: #ffffff


    // 電腦版選單
    .bottom
        +bottom_Text_Setting(100%, auto, 16px, 1.58px, 1.95)
        padding: 0px 0 50px 0

        @media all and (max-width: $big_media)
            display: none

        // 大標題
        .col_1
            padding: 0
            h2
                width: fit-content
                margin-top: 59px
                margin-left: 0
                line-height: 1.39
                letter-spacing: 2.21px
                font-size: 28px
                @include desktop_small_width()
                    margin-left: auto
                    margin-right: auto
                    font-size: 24px
        h4
            margin-bottom: 20px
        .col_2, .col_3
            margin-top: 70px
            .rowTitle
                +rowTitle_Setting()
                margin-bottom: 20px

    // 手機版面選單
    $_top_bottom_mobile: 36px
    $_left_bottom_mobile: 74px
    .bottom_mobile
        +bottom_Text_Setting(100%, auto, 20px, 0.95px, 1.83)
        display: none
        @media all and (max-width: $big_media)
            display: block
        
        h4
            margin-bottom: 28px
            @include phone_width()
                font-size: 14px
                margin-bottom: 10px
        .row
            margin-right: 0
        .col
            padding: 0
        .col_4_2, .col_4_3, .col_5_2, .col_5_3
            padding: 0
        .col_4
            margin: $_top_bottom_mobile 0px 0px $_left_bottom_mobile
        .col_5
            margin-top: 50px
            margin: $_top_bottom_mobile 0px 28px $_left_bottom_mobile
        .col_4, .col_5
            padding: 0
            @include phone_width()
                margin-left: 8%
            .rowTitle
                +rowTitle_Setting()
                margin-bottom: 40px
                @include phone_width()
                    font-size: 14px
                    margin-bottom: 20px
        
    
footer
    .footer_nanya_mall
        a
            margin-top: 15px
            display: inline-block
            color: #FFFFFF
            img 
                width: 100%
                max-width: 250px
                display: block
                transform: translateX(-20px)

#copyRight
    +size(100%,auto)
    background-color: #6298bc
    margin: 0
    padding: 20px 15px
    @include phone_width()
        // height: 44px
        height: auto
    @media all and (max-width: 380px)
        height: auto
    p
        font-size: 16px
        line-height: 1.44
        letter-spacing: 1.26px
        color: white
        font-family: PingFangTC
        font-weight: normal
        font-stretch: normal
        font-style: normal
        margin: 0
        text-align: center
        @include tablet_small_width()
            font-size: 14px
        @include phone_width()
            font-size: 8px
            line-height: 14px
            letter-spacing: 0.63px
            text-align: center
        // @media all and (max-width: 380px)
        //     line-height: 2

//共用內容

//------slogan------//
.slogan
    p
        font-size: 20px
        @media all and ( max-width: 991px )
            font-size: 16px
            
</style>
